import { ActionTree } from "vuex";
import { DeviceState } from "./state";

const actions: ActionTree<DeviceState, any> = {
  //
};

export default actions;
